import { takeLatest } from 'redux-saga'
import { put, call, select } from 'redux-saga/effects'
import { destroyProjectsSelector } from 'selectors'
import destroyDocumentSaga from 'sagas/destroyDocumentSaga'
import { applyProjectsAction, expandProjectAction, removeProjectAction } from 'actions/projectActions'
import clearMapComponents from 'helpers/map/clearMapComponents'
import createDocumentSaga from 'sagas/createDocumentSaga'
import initialProject from 'helpers/projects/initialProject'
import { DESTROY_PROJECT } from 'actions/projectActionTypes'
import { notifyHoneybadgerAction, waitForMapIdleAction } from 'actions/applicationActions'
import getDocument from 'helpers/databases/getDocument'
import { clearCamerasAction } from 'actions/cameraActions'

export function * destroyProject(action) {
  try {
    const { projects, currentProjectId, map, map: { zoom, location },
      cameras, database } = yield select(destroyProjectsSelector)
    const { id } = action

    yield call(destroyDocumentSaga, id)
    yield put(removeProjectAction(id))

    if (projects.filter(p => p.id !== id).length === 0) {
      const document = Object.assign({}, initialProject(), { zoom, location })
      const idAndRev = yield call(createDocumentSaga, document)
      const project = { ...document, ...idAndRev }

      yield put(applyProjectsAction([project]))
      yield call(clearMapComponents, { map, cameras })
      yield put(waitForMapIdleAction(map.ref))
      yield put(clearCamerasAction())
      yield put(expandProjectAction(project))
    } else if (currentProjectId === id) {
      const project = yield call(
        getDocument,
        database,
        projects.slice().sort((a, b) => b.updatedAt - (a.updatedAt || 0)).find(p => p.id !== id).id
      )
      yield call(clearMapComponents, { map, cameras })
      yield put(waitForMapIdleAction(map.ref))
      yield put(clearCamerasAction())
      yield put(expandProjectAction(project))
    }
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

/** Watch for calculator update dispatch, then call function */
export function * watchDestroyProject() {
  yield * takeLatest(DESTROY_PROJECT, destroyProject)
}



// WEBPACK FOOTER //
// ./src/sagas/destroyProjectSaga.js